import React, { useEffect, useState } from 'react'
import getPerson from '../../Services/Queries/GetPerson'
import CreatePerson from './CreatePerson'
import { Col, Row } from 'react-bootstrap'
import AwsConfig from '../../Config/AwsConfig'
import MovieAutoSuggestionsdata from '../Movie/movieSearchAutosuggestion'
import { useHistory } from 'react-router-dom'
import LoadingSpinner from '../Movie/Loading'

const EditPerson = () => {
  // State variables for this file
  const [editPersonData, seteditPersonData] = useState({ items: [] })
  const [editPersonPrimarykey, seteditPersonPrimarykey] = useState('')
  const [editPersonBoolean, seteditPersonBoolean] = useState(false)
  // const [getPersonInput, setgetPersonInput] = useState({})
  const [AutoSuggestion, setAutoSuggetions] = useState([])
  const [disabled, setdisabled] = useState(true)
  const [Data, setData] = useState()
  const [loadSpinner, setLoadSpinner] = useState(false)
  const history = useHistory()

  // Function to call getperson service
  const getPersonData = async input => {
    try {
      const editPersonData = await getPerson(input)

      seteditPersonData(editPersonData)
      setLoadSpinner(false)
      setData(editPersonData.status)
    } catch (err) {
      console.warn(err)
      seteditPersonData({})
      setLoadSpinner(false)
    }
  }

  const poster = url => {
    if (url) {
      const cdnurl = AwsConfig.movieCdnUrl
      if (url && !url.includes(cdnurl)) {
        url = cdnurl + url
        return url
      }

      return url
    }

    return ''
  }

  const getSuggestions = async value => {
    seteditPersonPrimarykey(value)
    try {
      if (value === '') {
        setAutoSuggetions([])
        setdisabled(true)
      } else {
        const input = {
          search: value,
          type: 'person',
          limit: 100,
          from: 0,
        }
        const autoSuggestions = await MovieAutoSuggestionsdata(input)

        setdisabled(true)
        setAutoSuggetions(
          autoSuggestions && autoSuggestions.personHits ? autoSuggestions.personHits : [],
        )
      }
    } catch (error) {
      console.error(error)
    }
  }

  // Function for saving primarykey for future use
  const editPersonPrimarykeyinput = suggestion => {
    setdisabled(false)
    seteditPersonPrimarykey(suggestion.PK)
    setAutoSuggetions([])
  }

  // Function for rendering edit form
  const rendereditform = () => {
    history.push(`/editperson?${editPersonPrimarykey}`)
    getPersonData({ PK: editPersonPrimarykey })
    seteditPersonBoolean(true)
  }

  // editPersonPrimarykeyinput(event)
  const handleUrlParameters = () => {
    setLoadSpinner(true)
    const url = window.location.href
    const urlSplit = url.split('?')

    seteditPersonPrimarykey(decodeURIComponent(urlSplit[1] ? urlSplit[1] : editPersonPrimarykey))
    // setgetPersonInput({
    //   PK: decodeURIComponent(urlSplit[1] ? urlSplit[1] : editPersonPrimarykey),
    // });
    seteditPersonBoolean(Boolean(urlSplit[1]))

    if (urlSplit[1]) {
      getPersonData({ PK: decodeURIComponent(urlSplit[1]) })
    } else {
      setLoadSpinner(false)
    }
  }

  // useEffect for input and primary key to pass into service
  useEffect(() => {
    handleUrlParameters()

    const handleVisibilityChange = () => {
      if (!document.hidden && !Data) {
        // Tab is visible, and movieData is not available, fetch data
        handleUrlParameters()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Fetch data when the component is mounted if movieData is not available
    if (!Data) {
      handleUrlParameters()
    }

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [Data])

  return (
    <div>
      {loadSpinner && <LoadingSpinner />}
      {
        <Row>
          <Col md={6} xs={12}>
            {!editPersonBoolean && (
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: '10px', margin: '20px' }}
              >
                <label>Person ID</label>
                <div>
                  <input
                    type='text'
                    className='form-control'
                    value={editPersonPrimarykey}
                    placeholder='please enter pk value'
                    onChange={event => getSuggestions(event.target.value)}
                  />
                </div>
                {AutoSuggestion && AutoSuggestion.length >= 1 && (
                  <div
                    style={{
                      border: ' 1px solid gray',
                      borderRadius: '6px 6px 6px 6px',
                      cursor: 'pointer',
                      maxHeight: '500px',
                      overflowY: 'scroll',
                    }}
                  >
                    {AutoSuggestion.map((suggestion, index) => (
                      <div key={index} onClick={() => editPersonPrimarykeyinput(suggestion)}>
                        <ul className='list-group list-group-flush mb-1'>
                          {suggestion.name_En && (
                            <li className='list-group-item'>
                              <div className='media d-flex justify-content-center align-items-center'>
                                <img
                                  style={{ width: '2rem', height: '2rem' }}
                                  className='rounded-circle mr-3'
                                  src={poster(suggestion ? suggestion.posterURL : '')}
                                  // alt={suggestion.name_En}
                                />
                                <div className='media-body align-self-center'>
                                  <label>{suggestion.name_En}</label>
                                </div>
                              </div>
                            </li>
                          )}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
                {disabled && <span className='mandatory1'>person Id should not be empty</span>}
                <div>
                  <button
                    type='button'
                    disabled={disabled}
                    className='btn btn-primary'
                    onClick={() => rendereditform()}
                  >
                    Edit Person
                  </button>
                </div>
              </div>
            )}
          </Col>
        </Row>
      }
      {editPersonPrimarykey && editPersonBoolean && (
        <CreatePerson
          mode={'Edit'}
          personData={editPersonData && editPersonData ? editPersonData : []}
          Editmode={'true'}
        />
      )}
    </div>
  )
}

export default EditPerson
